// src/components/AppVersions/VersionDetailsModal.jsx
import { createPortal } from "react-dom";
import {
  Overlay,
  DetailsCard,
  DetailsCloseButton,
  DetailRow,
  DetailLabel,
  DetailLink,
  DetailEmpty,
} from "./styles";

function DownloadIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M12 3v12" strokeLinecap="round" />
      <path d="M6 11l6 6 6-6" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M4 21h16" strokeLinecap="round" />
    </svg>
  );
}

export function VersionDetailsModal({ version, onClose }) {
  if (!version) return null;

  const storeLink = version.platform === "ios" ? version.apple_store_link : version.playstore_link;
  const storeLinkLabel = version.platform === "ios" ? "Link App Store" : "Link Play Store";
  const binaryLabel = version.platform === "ios" ? "Arquivo IPA" : "Arquivo AAB";

  return createPortal(
    <Overlay onClick={onClose} role="dialog" aria-modal="true">
      <DetailsCard onClick={(e) => e.stopPropagation()}>
        <DetailsCloseButton type="button" onClick={onClose} aria-label="Fechar">
          ×
        </DetailsCloseButton>

        <h2>
          {version.version} · {version.platform}
        </h2>

        <DetailRow>
          <DetailLabel>Descrição</DetailLabel>
          {version.description ? (
            <span>{version.description}</span>
          ) : (
            <DetailEmpty>Sem descrição</DetailEmpty>
          )}
        </DetailRow>

        <DetailRow>
          <DetailLabel>{storeLinkLabel}</DetailLabel>
          {storeLink ? (
            <DetailLink href={storeLink} target="_blank" rel="noopener noreferrer">
              {storeLink}
            </DetailLink>
          ) : (
            <DetailEmpty>Não informado</DetailEmpty>
          )}
        </DetailRow>

        <DetailRow>
          <DetailLabel>Manual (PDF)</DetailLabel>
          {version.manual_pdf_download_url ? (
            <DetailLink href={version.manual_pdf_download_url} target="_blank" rel="noopener noreferrer">
              <DownloadIcon /> Baixar manual
            </DetailLink>
          ) : (
            <DetailEmpty>Nenhum manual anexado</DetailEmpty>
          )}
        </DetailRow>

        <DetailRow>
          <DetailLabel>{binaryLabel}</DetailLabel>
          {version.binary_download_url ? (
            <DetailLink href={version.binary_download_url} target="_blank" rel="noopener noreferrer">
              <DownloadIcon /> Baixar {binaryLabel.toLowerCase()}
            </DetailLink>
          ) : (
            <DetailEmpty>
              {version.channel === "store" ? "Arquivo não disponível" : "Não aplicável (OTA)"}
            </DetailEmpty>
          )}
        </DetailRow>
      </DetailsCard>
    </Overlay>,
    document.body
  );
}
